"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedSignalDriveModesFormPayloadSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
exports.NormalizedSignalDriveModesFormPayloadSchema = z.object({
    signals: sigma_engine_shared_1.SignalSchema.array(),
    modes: sigma_engine_shared_1.ModeBaseSchema.array(),
});
//# sourceMappingURL=payload.js.map